var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('h3',[_vm._v("Request")]),_c('table',[_c('tbody',_vm._l((_vm.tripDetailsRequest),function(el,idx){return _c('tr',{key:idx},[_c('td',[_vm._v(" "+_vm._s(el.name)+" ")]),_c('td',{staticClass:"d-flex justify-content-end",style:({
            'color': el.colored ? '#28c76f' : ''
          })},[_vm._v(" "+_vm._s(el.value)+" ")])])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }